import { FormSchema } from './form-schema';
import { TOP_BOTTOM_NAMES } from '../slides/overview-slide-interface';
// TODO: fix circular dependency and import directly from @features/reports
// eslint-disable-next-line local/no-deep-imports
import { dimensionSlugs } from '@features/reports/domain/dimensions';

export const defaultValues: FormSchema = {
  campaignName: '',
  ftaSummary: '',
  rsaSummary: '',
  ftaOverallResults: '',
  rsaOverallResults: '',
  cmOverall: '',
  cmInStore: '',
  cmOnline: '',
  rsaSummaryTable: '',
  includedSlidesPreset: 'default',
  includedSlides: {
    overall: {
      overview: true,
      executiveSummary: true,
    },
    footTraffic: {
      titleSlide: true,
      overallResults: true,
      optimizationIndex: true,
      dimensions: true,
    },
    salesAttribution: {
      titleSlide: true,
      summary: true,
      contributionMetrics: true,
      summaryTable: true,
      dimensions: true,
    },
    campaignAnalytics: {
      titleSlide: true,
      audienceProfile: true,
      demographicProfile: true,
      stateAndDmaVisits: true,
      brandLocationVisits: true,
      proximityToHome: true,
      timeToFirstVisitByDay: true,
      visitsByHourOfDay: true,
      visitsByDayOfWeek: true,
      footTrafficOverlap: true,
    },
    appendix: true,
  },
  youtubeImpressions: null,
  dimensions: [...dimensionSlugs, ...TOP_BOTTOM_NAMES].reduce(
    (acc, dimensionSlug) => {
      acc[dimensionSlug] = {
        checkbox: true,
        visitsTableHeader: '',
        salesTableHeader: '',
      };
      return acc;
    },
    {} as FormSchema['dimensions']
  ),
};
